const getters = {
    version: state => state.version,
    backendServer: state => state.backendServer,
    registrationEnabled: state => state.registrationEnabled,
    turnstileSiteKey: state => state.turnstileSiteKey,
    baseRedirectServer: state => state.baseRedirectServer,
    error: state => state.error,
    snackbar: state => state.snackbar,
    universalAlert: state => state.universalAlert
  };
  
  export default getters;
  